const root = "_root_ssths_24";
const field = "_field_ssths_34";
const label = "_label_ssths_67";
const message = "_message_ssths_93";
const styles = {
  root,
  field,
  "inline-field": "_inline-field_ssths_40",
  "inline-field-body": "_inline-field-body_ssths_46",
  "inline-field-control": "_inline-field-control_ssths_52",
  label,
  message,
  "help-message": "_help-message_ssths_99",
  "error-message": "_error-message_ssths_103",
  "success-message": "_success-message_ssths_107"
};
export {
  styles as default,
  field,
  label,
  message,
  root
};
//# sourceMappingURL=form.module.css.js.map
